import { useState } from "react";
import { Alert, Card, Stack, Text } from "@/components/ui";
import { useCatalogoPermisos } from "../hooks/use-permisos-admin";
import { PermisosHeader } from "./PermisosHeader";
import { PermisoCrearForm } from "./PermisoCrearForm";
import { PermisosTable } from "./PermisosTable";

/**
 * Gestor del catálogo de permisos (RBAC · P46). El catálogo se siembra desde el
 * código; aquí el admin edita metadatos (grupo/descripción), activa/desactiva y
 * registra permisos personalizados. El enforcement de acceso lo sigue haciendo el
 * código — un permiso nuevo no otorga nada hasta que se cablea.
 */
export function AdminPermisosPage() {
  const [modoCrear, setModoCrear] = useState(false);
  const { data: permisos } = useCatalogoPermisos();

  const personalizados = permisos.filter((p) => !p.esDeSistema).length;

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <PermisosHeader
        total={permisos.length}
        personalizados={personalizados}
        modoCrear={modoCrear}
        onIniciarCrear={() => setModoCrear(true)}
      />
      <Stack gap="md">
        <Alert variant="info" title="Un permiso solo actúa si el código lo exige">
          <Text size="sm">
            Editar la <b>descripción/grupo</b> y <b>activar/desactivar</b> aplica de inmediato (controla cómo se ve
            y si se puede asignar). En cambio, un permiso que <b>agregues</b> aquí queda «pendiente de cablear»:
            es asignable a roles pero <b>no otorga acceso</b> hasta que un desarrollador lo conecte con un
            <code> .RequirePermiso</code> en el backend (o un <code>PermissionGate</code> en el front). Los permisos
            del sistema (con candado) están definidos en código: se editan y desactivan, pero no se eliminan.
          </Text>
        </Alert>
        {modoCrear ? <PermisoCrearForm onSalir={() => setModoCrear(false)} /> : null}
        <Card padding="lg">
          <PermisosTable permisos={permisos} />
        </Card>
      </Stack>
    </div>
  );
}
